<template>
  <v-container 
  v-if="isDataReady"
  fluid>
    <div class="d-flex flex-column pb-10">
      <h4>
        {{$t('pages.repair.updateDataShippingDetailsTab')}}
      </h4>
    </div>
    <section-title-with-request-id
    :request-id="repairProp.number"
    title="pages.repair.contactDetails"
    class="mb-3"/>
    <v-form
    ref="form"
    v-model="isFormValid">
      <v-row dense>
        <v-col class="mr-4">
          <text-field-value 
          v-model="getAddress.companyName" 
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE', 'SUSTAINABILITY_MANAGER', 'SUSTAINABILITY_MANAGER'])"
          :label="$t('textFields.companyName')"
          required/>
        </v-col>
        <v-col class="mr-4">
          <text-field-first-name 
          v-model="getContact.firstName" 
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE', 'SUSTAINABILITY_MANAGER', 'SUSTAINABILITY_MANAGER'])"
          required/>
        </v-col>
        <v-col class="ml-4">
          <text-field-last-name 
          v-model="getContact.lastName" 
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE', 'SUSTAINABILITY_MANAGER', 'SUSTAINABILITY_MANAGER'])"
          required/>
        </v-col>
      </v-row>
      <v-row dense class="mt-5">
        <v-col class="mr-4">
          <text-field-phone 
          v-model="getContact.phone" 
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE', 'SUSTAINABILITY_MANAGER', 'SUSTAINABILITY_MANAGER'])"
          required/>
        </v-col>
        <v-col class="ml-4">
          <text-field-email
          :label="$t('textFields.email')"
          v-model="getContact.email" 
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE', 'SUSTAINABILITY_MANAGER', 'SUSTAINABILITY_MANAGER'])"
          required/>
        </v-col>
      </v-row>
      <v-row v-for="(r, i) in getBackupEmailsPositions()" 
      class="mt-5"
      :key="i + 100"  
      dense 
      no-gutters >
        <v-col v-if="r.col1 && r.col1 !== 'btn'" class="mr-4">
          <text-field-email
          :label="$t('textFields.email')"
          v-model="r.col1.value"
          @click:append="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE', 'SUSTAINABILITY_MANAGER']) ? '' : removeNewBackUpEmail(r.col1)"
          required
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE', 'SUSTAINABILITY_MANAGER'])"
          append-icon="mdi-minus"/>
        </v-col>
        <v-col v-else-if="r.col1 && r.col1 === 'btn'" class="d-flex justify-center align-center mr-4">
          <v-btn
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE', 'SUSTAINABILITY_MANAGER'])"
          @click="addNewBackUpEmail"
          icon>
            <v-icon color="blue">
              mdi-plus
            </v-icon>
          </v-btn>
        </v-col>
        <v-col v-if="r.col2 && r.col2 !== 'btn'" class="ml-4">
          <text-field-email
          :label="$t('textFields.email')"
          v-model="r.col2.value"
          @click:append="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE', 'SUSTAINABILITY_MANAGER']) ? '' : removeNewBackUpEmail(r.col2)"
          append-icon="mdi-minus"
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE', 'SUSTAINABILITY_MANAGER'])"
          required/>
        </v-col>
        <v-col v-else-if="r.col2 && r.col2 === 'btn'" class="d-flex justify-center align-center ml-4">
          <v-btn
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE', 'SUSTAINABILITY_MANAGER'])"
          @click="addNewBackUpEmail"
          icon>
            <v-icon color="blue">
              mdi-plus
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row
      v-if="getBackupEmailsPositions().length === 0">
        <v-col class="d-flex justify-center align-center ml-4">
          <v-btn
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE', 'SUSTAINABILITY_MANAGER'])"
          @click="addNewBackUpEmail"
          icon>
            <v-icon color="blue">
              mdi-plus
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row dense no-gutters class="mt-10">
          <v-col>
            <p class="process-repair-tab-section-title">{{$t('pages.repair.addressDetails')}}</p>
          </v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col>
          <text-field-value 
          v-model="getAddress.country" 
          :label="$t('textFields.country')" 
          class="mr-4" 
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE', 'SUSTAINABILITY_MANAGER'])"
          required/>
        </v-col>
        <v-col>
          <text-field-value 
          v-model="getAddress.province" 
          :label="$t('textFields.state')" 
          class="ml-4" 
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE', 'SUSTAINABILITY_MANAGER'])"/>
        </v-col>
      </v-row>
      <v-row dense no-gutters class="mt-5">
        <v-col>
          <text-field-value 
          v-model="getAddress.city" 
          :label="$t('textFields.city')" 
          class="mr-4"
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE', 'SUSTAINABILITY_MANAGER'])"
          required/>
        </v-col>
        <v-col>
          <text-field-value 
          v-model="getAddress.postalCode" 
          :label="$t('textFields.postalCode')" 
          class="ml-4"
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE', 'SUSTAINABILITY_MANAGER'])"
          required/>
        </v-col>
      </v-row>
      <v-row dense no-gutters class="mt-5">
        <v-col>
          <text-field-value 
          v-model="getAddress.street" 
          :label="$t('textFields.streetDetails')" 
          class="mr-4"
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE', 'SUSTAINABILITY_MANAGER'])"
          required/>
        </v-col>
        <v-col>
          <text-field-value 
          v-model="getAddress.building"
          :label="$t('textFields.building')" 
          class="ml-4"
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE', 'SUSTAINABILITY_MANAGER'])"/>
        </v-col>
      </v-row>
      <add-packages-list
      v-model="packagesProp"
      :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE', 'SUSTAINABILITY_MANAGER'])"
      :set-default-row="$parent.isRole(['ADMIN', 'SUPER_ADMIN', 'CLIENT'])"/>
    </v-form>
    <v-row
    v-if="showRejectedPartsIfAny"
    dense
    no-gutters
    class="mt-10">
      <v-col
      class="d-flex align-center">
        <p class="process-repair-tab-section-title mr-2 mt-4" style="color: red;">{{$t('pages.repair.rejectedParts')}}</p>
        <mdi-icon
        src="alert-circle"
        :size="27"
        color="red"/>
      </v-col>
    </v-row>
    <v-row
    v-if="showRejectedPartsIfAny"
    dense
    no-gutters>
      <v-col>
        <h4 class="mb-2">
          {{$t('pages.repair.doNotSendRejectedParts')}}
        </h4>
        <rejected-repair-part-table
        :items="getRejectedParts"/>
      </v-col>
    </v-row>
    <v-row 
    v-if="$parent.isRole(['ADMIN', 'SUPER_ADMIN', 'CLIENT'])"
    dense 
    class="my-10">
      <v-col>
        <p class="text-center"
        style="font-weight: bold">
          {{$t('common.pressContinueWhenReady')}}
        </p>
        <process-repair-quick-btns 
        :loading.sync="isLoading"
        :config="getQuickBtnsConfig"
        on-success-repair-status-message="dialogs.messages.success.toWaitingForPickUpStep"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col
      class="d-flex justify-end">
        <primary-btn
        v-if="$parent.isRole(['ADMIN', 'SUPER_ADMIN'])"
        @click="openDeleteDialog"
        color="red"
        :width="120"
        :height="45"
        :disabled="disabled"
        :loading="isLoading"
        class="mx-2"
        :label="$t('btns.delete')"/>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import TextFieldFirstName from '@/components/text-fields/TextFieldFirstName'
import TextFieldLastName from '@/components/text-fields/TextFieldLastName'
import TextFieldPhone from '@/components/text-fields/TextFieldPhone'
import TextFieldEmail from '@/components/text-fields/TextFieldEmail'
import TextFieldValue from '@/components/text-fields/TextFieldValue'
import PrimaryBtn from '@/components/btns/PrimaryBtn'
import AddPackagesList from '@/components/common/process-tabs/shared/AddPackagesList'
import ProcessRepairQuickBtns from '@/components/process-repair-tabs/ProcessRepairQuickBtns'
import SectionTitleWithRequestId from '@/components/common/process-tabs/shared/SectionTitleWithRequestId'
import MdiIcon from '@/components/btns/MdiIcon'
import RejectedRepairPartTable from '@/components/basic-tables/RejectedRepairPartTable'
import { updateShippingData, deleteRepairInShippingDetailTab } from '@/repositories/repairRepo'
import { execHttpRequestThrowable } from '@/services/http'
//ENABLE_CHANGE_DIALOG - This method is needed for changes dialog.
// compareObjects
import { copyObj, cloneObj } from '@/utils/StringUtil'
import { routeFromRoot } from '@/services/routeService'
import { getObjectPartCategoryByKey } from "@/utils/statusesUtil"
export default {
  name: 'ShippingDetailsTabRepair',
  components: {
    TextFieldFirstName,
    TextFieldLastName,
    TextFieldPhone,
    TextFieldEmail,
    TextFieldValue,
    PrimaryBtn,
    AddPackagesList,
    ProcessRepairQuickBtns,
    SectionTitleWithRequestId,
    RejectedRepairPartTable,
    MdiIcon
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    disabled: Boolean
  },
  data() {
    return {
      isFormValid: false,
      newData: null,
      isLoading: false,
      isDataReady: false
    }
  },
  methods: {
    async tryToSaveData() {
      const messages = {
        _200: 'dialogs.messages.success.pickUpDataSavedSuccessfully'
      }
      const r = await execHttpRequestThrowable(async () => await updateShippingData(this.$route.params.id, this.newData.pickUpShippingDetails),
      messages,
      v => this.isLoading = v)
      cloneObj(this.newData.pickUpShippingDetails, this.repairProp.pickUpShippingDetails)
      this.newData.isAllowedToContinue = r.response.data
    },
    async tryToDeleteRepair() {
      const messages = {
        _200: 'dialogs.messages.success.repairDeletedSuccessfully'
      }

      await execHttpRequestThrowable(async () => await deleteRepairInShippingDetailTab(this.$route.params.id),
      messages,
      v => this.isLoading = v)
      routeFromRoot('active-repairs')
    },
    openDeleteDialog() {
      this.$confirmActionDialog.open('pages.repair.deleteRepair',
      null,
      'btns.delete',
      null,
      this.tryToDeleteRepair)
    },
    setChangedDialogItems() {
      this.tryToSaveData()  
      // NOTE: ENABLE_CHANGE_DIALOG - Enable this code, if changes dialog is needed.
      //-----------------------------------------------------------------
      // const old = this.repairProp.pickUpShippingDetails
      // const _new = this.newData.pickUpShippingDetails

      // const props = [
      //   {
      //     field: 'textFields.firstName',
      //     prop: 'contact.firstName'
      //   }, {
      //     field: 'textFields.lastName',
      //     prop: 'contact.lastName'
      //   }, {
      //     field: 'textFields.phone',
      //     prop: 'contact.phone'
      //   }, {
      //     field: 'textFields.email',
      //     prop: 'contact.email'
      //   }, {
      //     field: {
      //       value: 'textFields.backupEmailNo',
      //       params: null
      //     },
      //     prop: 'contact.backupEmails[].value'
      //   }, {
      //     field: 'textFields.companyName',
      //     prop: 'address.companyName'
      //   }, {
      //     field: 'textFields.country',
      //     prop: 'address.country'
      //   }, {
      //     field: 'textFields.state',
      //     prop: 'address.province'
      //   }, {
      //     field: 'textFields.city',
      //     prop: 'address.city'
      //   }, {
      //     field: 'textFields.postalCode',
      //     prop: 'address.postalCode'
      //   }, {
      //     field: 'textFields.street',
      //     prop: 'address.street'
      //   }, {
      //     field: 'textFields.building',
      //     prop: 'address.building'
      //   }, {
      //     field: {
      //       value: 'textFields.dimensionsNo',
      //       params: null
      //     },
      //     prop: 'packages[].dimensions'
      //   }, {
      //     field: {
      //       value: 'textFields.weightNo',
      //       params: null
      //     },
      //     prop: 'packages[].weight'
      //   }
      // ]

      // this.$changesDialog.open(
      //   'dialogs.titles.changes',
      //   compareObjects(old, _new, props),
      //   this.tryToSaveData,
      //   false
      // )
      //-----------------------------------------------------------------
    },
    addNewBackUpEmail() {
      this.getContact.backupEmails.push({
        id: null,
        value: ''
      })
    },
    removeNewBackUpEmail(e) {
      this.getContact.backupEmails = this.getContact.backupEmails.filter(be => be !== e)
    },
    getBackupEmailsPositions() {
      const rows = []
      let changeRow = true
      let i = -1
      let c = 0

      for (const be of this.getContact.backupEmails) {
        c++
        if (changeRow) {
          changeRow = false
          i++
          rows[i] = {
            col1: be,
            col2: 'btn'
          }
        }
        if (c === 2) {
          rows[i].col2 = be
          c = 0
          changeRow = true
        }
      }

      if (rows.length > 0 && rows[rows.length - 1].col2 !== 'btn') {
        rows.push({
          col1: 'btn',
          col2: null
        })
      }

      return rows
    }
  },
  computed: {
    getContact() {
      return this.newData.pickUpShippingDetails.contact
    },
    getAddress() {
      return this.newData.pickUpShippingDetails.address
    },
    getRejectedParts() {
      return this.repairProp.repairParts
      .filter(o => o.initialApproval === "REJECTED")
      .map(o => {
        return {
          imageUrl: o.imageUrl,
          category: getObjectPartCategoryByKey(o.category).name,
          partName: o.partName,
          serialNumber: o.serialNumber,
          serviceTag: o.serviceTag
        }
      })
    },
    showRejectedPartsIfAny() {
      return this.$parent.isRole(["CLIENT"]) && this.repairProp.repairParts.filter(o => o.initialApproval === "REJECTED").length > 0
    },
    packagesProp: {
      get: function() {
        return this.newData.pickUpShippingDetails.packages
      },
      set: function(v) {
        this.newData.pickUpShippingDetails.packages = v
      }
    },
    repairProp: {
      get: function() {
        return this.$props.data
      },
      set: function(v) {
        this.$emit('update:data', v)
      }
    },
    getQuickBtnsConfig() {
      return [
        {
          name: 'Save',
          events: {
            'click': this.setChangedDialogItems
          },
          props: {
            'disabled': this.disabled || !this.isFormValid || this.packagesProp.length === 0
          }
        }, {
          name: 'Continue',
          props: {
            'disabled': this.disabled || !this.newData.isAllowedToContinue,
          },
          overrideProps: {
            "label": "btns.submit"
          }
        }
      ]
    }
  },
  mounted() {
    this.newData = {
      isAllowedToContinue: this.repairProp.isAllowedToContinue,
      pickUpShippingDetails: copyObj(this.repairProp.pickUpShippingDetails)
    }
    this.isDataReady = true
  }
}
</script>
<style>

</style>